module.exports = __webpack_public_path__ + "static/img/recording_title.0a826e4e.svg";